import type { VersionListItem } from '@/lib/apiTypes'
import { BlockedBadge } from '@/shared/components/BlockedBadge'

// ── Badges for version table (rendered from the list-row payload) ──────────────
export function VersionScanBadge({ v }: { v: VersionListItem }) {
  if (v.status === 'pending' || v.status === 'processing') {
    return <span className="badge badge-neutral"><span className="spinner" style={{ width: 10, height: 10, marginRight: 4 }} />scan pending</span>
  }
  if (v.status === 'failed') return <span className="badge badge-neutral">scan failed</span>
  if (v.critical_count > 0) return <span className="badge badge-red">⚠ {v.critical_count} critical</span>
  if (v.high_count > 0) return <span className="badge badge-amber">{v.high_count} high</span>
  if (v.low_count > 0) return <span className="badge badge-neutral">{v.low_count} low</span>
  return <span className="badge badge-green">✓ clean</span>
}

export function VersionConsumableBadge({ v }: { v: VersionListItem }) {
  if (v.status !== 'published') return <span style={{ color: 'var(--text3)', fontSize: '0.75rem' }}>-</span>
  if (v.manually_blocked) return <BlockedBadge label="✗ blocked" manual reason={v.block_reason} blockedByName={v.blocked_by_name} blockedAt={v.blocked_at} />
  if (v.consumable_override) return <span className="badge badge-amber">⚠ force-allowed</span>
  if (!v.consumable) return <BlockedBadge label="✗ blocked" policySummary={v.policy_block_summary} />
  return <span className="badge badge-green">✓ consumable</span>
}
